<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>内推资讯管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreatePosterDialog()">
          新增内推海报
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="posters"
      :items-per-page="pageSize"
      :server-items-length="totalItems"
      :page.sync="page"
      :loading="loading"
      @update:page="fetchPosters"
      class="elevation-1"
    >
      <template v-slot:[`item.coverImageUrl`]="{ item }">
        <v-img
          :src="item.coverImageUrl"
          max-height="400"
          max-width="400"
          contain
        ></v-img>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showEditPosterDialog(item)" icon>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn small @click="showDeletePosterConfirm(item)" icon>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

        <!-- 删除确认对话框 -->
        <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">确认删除</v-card-title>
        <v-card-text>
          确定要删除这个内推海报吗？此操作不可恢复！
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteDialog = false">取消</v-btn>
          <v-btn color="error" text @click="confirmDelete" :loading="deleting">确认删除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <create-poster-popup ref="createPopup" @poster-created="refreshList" />
    <edit-poster-popup 
    ref="editPosterPopup"
    @poster-updated="fetchPosters"
  ></edit-poster-popup>
  </v-container>
</template>

<script>
import { posterApi } from '@/api/poster'
import EditPosterPopup from '@/components/EditPosterPopup'
import CreatePosterPopup from '@/components/CreatePosterPopup'


export default {
  name: 'NeiTuiManagement',
  components: {
    EditPosterPopup, CreatePosterPopup
  },
  data() {
    return {
      headers: [
        { text: "封面图", value: "coverImageUrl", sortable: false },
        { text: "操作", value: "actions", sortable: false }
      ],
      posters: [],
      selectedCompany: {},
      loading: false,
      deleteDialog: false,
      deleting: false,
      currentPosterId: null,
      page: 1,
      pageSize: 10,
      totalItems: 0
    };
  },
  mounted() {
    this.fetchPosters();
  },
  methods: {
    async fetchPosters() {
      this.loading = true;
      try {
        const response = await posterApi.getPosters({
          page: this.page,
          pageSize: this.pageSize
        });

        if (response.code === '2000') {
          this.posters = response.data.posterInfos;
          this.totalItems = response.data.pageTotal * this.pageSize;
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取内推数据失败 : ', errorMessage);
      } finally {
        this.loading = false;
      }
    },

    showCreatePosterDialog() {
      this.$refs.createPopup.open();
    },

    showEditPosterDialog(item) {
      this.$refs.editPosterPopup.posterId = item.posterId;
      this.$refs.editPosterPopup.open(item.posterId);
    },

    showDeletePosterConfirm(item) {
      this.currentPosterId = item.posterId
      this.deleteDialog = true
    },

    async confirmDelete() {
      this.deleting = true
      try {
        const response = await posterApi.deletePoster(this.currentPosterId)
        if (response.code === '2000') {
          this.fetchPosters() // 刷新列表
          this.deleteDialog = false
          this.$toast.success('删除成功')
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('删除失败 : ', errorMessage);
      } finally {
        this.deleting = false
      }
    },

    refreshList() {
      this.fetchPosters();
    },
  },
};
</script>
